import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Estimator from "@/components/site/Estimator";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import HeroChatbot from "@/components/site/HeroChatbot";

export default function Landing() {
  return (
    <div className="grain min-h-screen bg-black text-white relative">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Estimator />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <HeroChatbot />
    </div>
  );
}
